import '../IdcGlobal.IBP.Web/js/Events.js'
